export const isRequired = (value: any) => {
  if (value === null || value.length === 0) {
    return "This field cannot be empty"
  } else {
    return null
  }
}
